import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast, ToastContainer} from "react-toastify";
import { forgotUser } from "../../actions/authActions";
import classnames from "classnames";
import authLogo from "../../images/magnituteLogo.png";
import { withTranslation } from 'react-i18next';
import { t } from "i18next";


class Forgot extends Component {
    constructor() {
        super();
        this.state = {
            email: "",
            errors: {}
        };
    }

    componentDidMount() {
        if (this.props.auth.isAuthenticated) {
            this.props.history.push("/dashboard");
        }
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.isAuthenticated) {
            this.props.history.push("/dashboard");
        }

        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
        else{
            this.setState({
                errors: {}
            });
        }
        if (nextProps.auth !=undefined && nextProps.auth.forgot != undefined)

             
        {   
            this.setState({
                email:""
            })
            toast(nextProps.auth.forgot, {
                position: toast.POSITION.TOP_CENTER
            });
         }
    }

    onChange = e => {
        this.setState({ [e.target.id]: e.target.value });
    };

    onSubmit = e => {
        e.preventDefault();
        const userData = {
            email: this.state.email,
        };
        this.props.forgotUser(userData);
    };

    render() {
        const { errors } = this.state;
        const {t}=this.props;
        return (
            <div className="container loginsec">
                 <div className="flex_center">
                <div className="row my-5">
                    <div className="col-md-12 mx-auto">
                    <div className="card">
                        <div className="card-body p-4">
                       <center className="pt-3">
                          {/* <h2 className="form_header">Bell Exchange</h2> */}
                          <img src={authLogo} className="img-fluid img_form" alt="Logo" />
                           </center>
                            <h2 className="text-center text-primary mt-3">{t("FORGOT PASSWORD")}</h2>
                            <form noValidate onSubmit={this.onSubmit} className="white formcur_default">
                                <label htmlFor="email">{t("EMAIL")}</label>
                                <input
                                    onChange={this.onChange}
                                    value={this.state.email}
                                    error={errors.email}
                                    id="email"
                                    type="email"
                                    className={classnames("form-control", {
                                        invalid: errors.email
                                    })}
                                />
                                <span className="text-danger">{errors.email}</span>
                                <br/>
                                <p className="text-center pb-0 mt-2">
                                    <button
                                        type="submit"
                                        className="btn btn-large btn-primary mt-0 px-5">
                                        {t("FORGOT")}
                                    </button>
                                </p><p className="grey-text text-darken-1 font_15 mt-4">
                                    {t("BACKTOLOGIN")} <Link to="/login" className="link_blue_new">{t("LOGIN")}</Link>
                                </p>
                            </form>
                        </div>
                    </div>
                    </div>
                    </div>
                </div>
                <ToastContainer/>

            </div>
        );
    }
}

Forgot.propTypes = {
    forgotUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});
export default connect(
    mapStateToProps,
    { forgotUser }
)(withTranslation()(Forgot),(Forgot));
